
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"2","rx":"1"}}),_c('rect',{attrs:{"y":"7","width":"20","height":"2","rx":"1"}}),_c('rect',{attrs:{"y":"14","width":"20","height":"2","rx":"1"}})])
          )
        }
      }
    